import axios from "axios";
import PropTypes from "prop-types";
import { createContext, useState, useReducer } from "react";
import useAuth from "src/hooks/useAuth";

const initialState = {
  firstName: "",
  email: "",
  userName: "",
  password: "",
  country: "",
  productId: "",
  paymethodId: "",
};

const handlers = {
  SET_USER_INFO: (state, action) => {
    return { ...state, ...action.payload };
  },
  SET_STEP: (state, action) => ({
    ...state,
    step: action.payload,
  }),
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthFlowContext = createContext({
  ...initialState,
  setUserInfor: () => {},
});

AuthFlowContextProvider.propTypes = {
  children: PropTypes.node,
};

function AuthFlowContextProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [method, setMethod] = useState("");
  const [state, dispatch] = useReducer(reducer, initialState);
  const [packages, setPackages] = useState([]);
  const [paymethods, setPaymethods] = useState([]);
  const [summary, setSummary] = useState(null);
  const [paymentDetail, setPaymentDetail] = useState(null);

  const { login, register } = useAuth();

  const getPackages = async () => {
    setLoading(true);
    await axios
      .get("https://api.senvod.acan.group/members/packages")
      .then((response) => {
        setPackages(response.data.products);
        setLoading(false);
      });
  };

  const getPaymethods = async () => {
    setLoading(true);
    await axios
      .get("https://api.senvod.acan.group/members/paymethods")
      .then((response) => {
        setPaymethods(response.data);
        setLoading(false);
      });
  };

  const handleSilentLogin = async () => {
    let values = {};
    values[method] = state[method];
    values.password = state.password;
    await login(values);
  };

  const setUserInfo = (userInfo) => {
    dispatch({
      type: "SET_USER_INFO",
      payload: userInfo,
    });
  };

  const setUserKey = (userKey, value) => {
    setMethod(userKey);
    setUserInfo({ [userKey]: value });
  };

  const handleRegister = async () => {
    setLoading(true);
    const {
      email,
      password,
      firstName,
      userName,
      country,
      productId,
      paymethodId,
    } = state;
    const response = await register({
      method,
      email,
      userName,
      password,
      firstName,
      lastName: "",
      country,
      productId,
      //   paysys_id: paymethodId,
      paysys_id: paymethods.find((i) => i.id === paymethodId).paysystemId,
    });

    if (response.data.status) {
      await handleSilentLogin();
      setSummary(response.data);
      setStep(4);
    }
  };

  const changeStep = async (stepNumber) => {
    if (stepNumber === 2 && packages.length === 0) {
      await getPackages();
    }
    if (stepNumber === 3 && paymethods.length === 0) {
      await getPaymethods();
    }
    if (stepNumber === 4) {
      await handleRegister();
    }
    setStep(stepNumber);
  };

  return (
    <AuthFlowContext.Provider
      value={{
        ...state,
        step,
        loading,
        packages,
        paymethods,
        changeStep,
        setUserInfo,
        summary,
        setUserKey,
        paymentDetail,
        setPaymentDetail,
      }}
    >
      {children}
    </AuthFlowContext.Provider>
  );
}

export { AuthFlowContext, AuthFlowContextProvider };
